<template>
  <div class="crud-services-customers">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading :module-id="access.module_id" :profile-id="access.profile_id" :reference="access.view_reference" summary-only />
          <div class="list-view-heading__controls"><div class="list-view-heading__actions"><TabHeaderActions /></div><div class="list-view-heading__controls-end"><b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }" v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen"><AppIcon name="filter" :fill="filtersOpen" /></b-button><b-button @click="add" type="button" variant="link" class="list-view-icon-btn list-view-icon-btn--primary" v-b-tooltip.hover.bottom title="Agregar servicio de cliente"><AppIcon name="add" /></b-button></div></div>
        </section>
        <b-collapse v-model="filtersOpen"><div class="list-view-toolbar__filters"><div class="list-view-filter" style="width: 220px;"><label class="filter-label">Buscar</label><b-form-input type="text" size="sm" placeholder="Nombre de referencia" v-model="filter.name" @keyup.enter.native="filterServicesCustomers" /></div><div class="list-view-filter" style="width: 280px;"><label class="filter-label">Clientes</label><v-select :options="arr.filter.customers" v-model="filter.customers" placeholder="Todos" :multiple="true" :select-on-tab="true" /></div><div class="list-view-filter" style="width: 160px;"><label class="filter-label">Estado</label><v-select :options="arr.filter.status" v-model="filter.status" placeholder="Activos" :multiple="true" :select-on-tab="true" /></div><b-button variant="outline-dark" size="sm" @click="filterServicesCustomers" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;"><AppIcon name="filter" /></b-button></div></b-collapse>
      </b-card>

      <b-card no-body class="mt-2">
            <b-table class="mb-0 app-table"
                    responsive
                    sticky-header="60vh"
                    :hover="true"
                    :stacked="isMobileViewport ? 'md' : false"
                    :fixed="!isMobileViewport"
                    :items="table.items"
                    :fields="table.fields"
                    :filter="table.filter"
                    :current-page="table.currentPage"
                    :per-page="table.perPage" 
                    :busy="table.isBusy"   
                    @row-clicked="openDetail"
                    v-if="table.items.length || table.isBusy">                       

                <template v-slot:table-colgroup="scope">
                  <col
                    v-for="field in scope.fields"                    
                    :key="field.key"
                    :style="{ width: field.width }"
                  >
                </template> 

                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando...</strong>
                  </div>
                </template>

                <template v-slot:row-details>
                  <b-row>
                    <b-col md="12">
                      <b-card no-body>
                        <b-table class="mb-0 app-table app-table--compact crud-services-customers-table-services"
                                responsive
                                :stacked="isMobileViewport ? 'md' : false"
                                :hover="true"
                                :fixed="false"
                                :items="tableServices.items"
                                :fields="tableServices.fields">  

                          <template v-slot:cell(services)="row">                            
                            {{row.item.service.name}}
                          </template>                

                          <template v-slot:cell(observations)="data">                      
                            <span v-if="data.item.observations">                                                    
                              <b-badge variant="dark" :id="'popover-observations-' + data.item.id" class="popover-observations">
                                <AppIcon name="notes" />
                              </b-badge>
                              <b-popover :target="'popover-observations-' + data.item.id" variant="default" triggers="hover">                            
                                <div v-html="data.item.observations"></div>
                              </b-popover>                                                    
                            </span>                          
                          </template>

                          <template v-slot:cell(date_init)="row">  
                            {{moment(row.item.date_init).format('DD/MM/YYYY')}}
                          </template>  

                          <template v-slot:cell(list)="data">     
                            <span v-if="data.item.price_list">
                              {{data.item.price_list.reference}}
                            </span>
                          </template>  

                          <template v-slot:cell(quantity)="row">                                  
                            <div v-if="row.item.service.mode=='hours'">
                              {{row.item.quantity}} {{row.item.service.mode}}
                            </div>                          
                          </template>                                                      

                          <template v-slot:cell(price)="row">                      
                            <span v-if="row.item.price_list">
                              {{Intl.NumberFormat('es-AR',{style:'currency',currency:row.item.price_list.currency.code}).format(row.item.price)}}
                            </span>
                            <span v-else>
                              {{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(row.item.price)}}
                            </span>
                          </template>

                          <template v-slot:cell(date_renewal)="row">  
                            <div v-if="row.item.canceled">
                              <b-badge variant="danger">FINALIZADO</b-badge>
                              <div class="crud-services-customers-reasons-canceled">
                                <AppIcon name="info" v-if="row.item.canceled" v-b-tooltip.hover :title="row.item.reasons_canceled" />
                              </div>                       
                            </div>

                            <div v-if="!row.item.canceled" class="pl-2 pr-2">
                              <div v-if="daysForRenewal(row.item)<1"
                                  class="crud-services-vto-danger">                                 
                                  {{moment(row.item.date_renewal).format('DD/MM/YYYY')}} 
                                  (Vencido por {{daysVtoRenewal(row.item)}} día/s)
                              </div>
                              <div v-else>
                                <div v-if="row.item.date_renewal" 
                                    :class="[daysForRenewal(row.item)<5 ? 'crud-services-vto-warning' : 'crud-services-vto-success']">
                                  {{moment(row.item.date_renewal).format('DD/MM/YYYY')}} 
                                  <b>(<span v-html="daysForRenewal(row.item)"></span> día/s)</b>
                                </div>
                              </div>

                              <div v-if="row.item.project_id">
                                <b-link @click="goProject(row.item)"> 
                                  <b>
                                    <AppIcon name="assignment" class="mr-1" /> Ver proyecto
                                  </b>
                                </b-link>
                              </div>                              
                            </div>
                          </template>  

                        </b-table>
                      </b-card>
                    </b-col>
                  </b-row>
                </template>

                <template v-slot:cell(id)="data">
                  <b>{{data.item.id}}</b>
                </template>

                <template v-slot:cell(name)="data">
                  {{data.item.name}}
                </template>

                <template v-slot:cell(date_init)="data">
                  {{moment(data.item.date_init).format('DD/MM/YYYY')}}                  
                </template>      

                <template v-slot:cell(date_end)="data">
                  <div v-if="data.item.date_end">
                    {{moment(data.item.date_end).format('DD/MM/YYYY')}}                  
                  </div>
                </template>   

                <template v-slot:cell(customers)="data">                  
                  <div v-if="data.item.customer_id">             
                    <b-avatar :src="data.item.customer.image"
                              v-if="data.item.customer.image">
                    </b-avatar>
                    <b-avatar v-else 
                              :text="avatarFromName(data.item.customer.name).text"
                              :style="avatarFromName(data.item.customer.name).style">
                    </b-avatar>     
                    &nbsp;<b>{{data.item.customer.name}}</b>      
                    <AppIcon name="cancel" v-if="!data.item.customer.active" class="ml-2 text-danger" v-b-tooltip.hover title="Cliente inactivo" />
                  </div>
                </template>                

                <template v-slot:cell(status)="data">
                  <div v-if="data.item.canceled">
                    <b-badge variant="danger">FINALIZADO</b-badge>
                  </div>
                  <div v-else>
                    <b-badge variant="success">ACTIVO</b-badge>
                  </div>
                </template>

                <template v-slot:cell(reasons)="data">
                  <div class="crud-services-customers-reasons-canceled">
                    <AppIcon name="info" v-if="data.item.canceled" v-b-tooltip.hover :title="data.item.reasons_canceled" />
                  </div>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right no-caret size="sm" variant="link" boundary="window" :toggle-class="isMobileViewport ? 'crud-services-customers-action-toggle' : 'app-table-action-toggle'" :class="{ 'pull-right': !isMobileViewport }">
                    <template #button-content><AppIcon name="more_vert" :class="{ 'mr-1': isMobileViewport }" /><span v-if="isMobileViewport">Opciones</span></template>
                    <b-dropdown-item @click="openCancel(data.item)" v-if="!data.item.canceled">
                      <AppIcon name="cancel" class="mr-1" /> Cancelar servicio
                    </b-dropdown-item> 
                    <b-dropdown-item @click="restoreServoceCancel(data.item)" v-else>
                      <AppIcon name="restore" class="mr-1" /> Restaurar servicio
                    </b-dropdown-item> 

                    <b-dropdown-header>Acciones</b-dropdown-header>  
                    <b-dropdown-item @click="edit(data.item)">
                      <AppIcon name="edit" class="mr-1" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <AppIcon name="delete" class="mr-1 text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else icon="design_services" title="No se encontraron servicios de clientes" />
            <div class="app-table-footer crud-services-customers-table-footer" v-if="table.items.length"><span>{{ getRowCount(table.items) }} registros</span></div>
      </b-card>

      <b-sidebar v-model="detailDrawer" right shadow backdrop title="Detalle del servicio" width="560px" @hidden="hideDetail">
        <div v-if="itemSelected" class="list-view-drawer crud-services-customers-drawer">
          <div class="list-view-drawer__header crud-services-customers-drawer__header"><b-avatar v-if="itemSelected.customer && itemSelected.customer.image" :src="itemSelected.customer.image" class="crud-services-customers-drawer__avatar" /><b-avatar v-else-if="itemSelected.customer" :text="avatarFromName(itemSelected.customer.name).text" :style="avatarFromName(itemSelected.customer.name).style" class="crud-services-customers-drawer__avatar" /><div class="list-view-drawer__title"><span v-if="itemSelected.customer" class="list-view-drawer__code">{{ itemSelected.customer.name }}</span><span v-else class="list-view-drawer__code">—</span><div class="list-view-drawer__meta">{{ itemSelected.name }}</div></div><div class="list-view-drawer__nav"><b-button size="sm" variant="outline-secondary" :disabled="!canGoPrevServiceCustomer" v-b-tooltip.hover title="Servicio anterior" @click="goPrevServiceCustomer"><AppIcon name="chevron-up" label="Servicio anterior" /></b-button><b-button size="sm" variant="outline-secondary" :disabled="!canGoNextServiceCustomer" v-b-tooltip.hover title="Servicio siguiente" @click="goNextServiceCustomer"><AppIcon name="chevron-down" label="Servicio siguiente" /></b-button></div></div>
          <div class="list-view-drawer__stats"><div class="list-view-drawer__stat"><span class="list-view-drawer__stat-label">Inicio</span><span class="list-view-drawer__stat-value">{{ moment(itemSelected.date_init).format('DD/MM/YYYY') }}</span></div><div v-if="itemSelected.canceled" class="list-view-drawer__stat"><span class="list-view-drawer__stat-label">Finalizó</span><span class="list-view-drawer__stat-value text-danger">{{ itemSelected.date_end ? moment(itemSelected.date_end).format('DD/MM/YYYY') : '—' }}</span></div><div class="list-view-drawer__stat"><span class="list-view-drawer__stat-label">Estado</span><span class="list-view-drawer__stat-value" :class="itemSelected.canceled ? 'text-danger' : 'text-success'">{{ itemSelected.canceled ? 'Finalizado' : 'Activo' }}</span></div></div>
          <div v-if="itemSelected.observations" class="mb-3"><div class="list-view-drawer__section-title"><AppIcon name="notes" /> Observaciones</div><div class="crud-services-customers-drawer__observations" v-html="itemSelected.observations"></div></div>
          <div><div class="list-view-drawer__section-title"><AppIcon name="design_services" /> Servicios contratados</div><div v-if="tableServices.items.length" class="crud-services-customers-drawer-services"><article v-for="detail in tableServices.items" :key="detail.id" class="crud-services-customers-drawer-service"><header><span class="crud-services-customers-drawer-service__icon"><AppIcon name="design_services" /></span><div><strong>{{ detail.service.name }}</strong><span v-if="detail.price_list">Lista {{ detail.price_list.reference }}</span></div><span class="crud-services-customers-drawer-service__status" :class="detail.canceled ? 'crud-services-customers-drawer-service__status--ended' : 'crud-services-customers-drawer-service__status--active'">{{ detail.canceled ? 'Finalizado' : 'Activo' }}</span></header><div v-if="detail.observations" class="crud-services-customers-drawer-service__observations" v-html="detail.observations"></div><div class="crud-services-customers-drawer-service__data"><div><span>Inicio</span><strong>{{ moment(detail.date_init).format('DD/MM/YYYY') }}</strong></div><div><span>Renovación</span><strong v-if="detail.canceled" class="text-danger">Finalizado</strong><strong v-else>{{ detail.date_renewal ? moment(detail.date_renewal).format('DD/MM/YYYY') : 'Sin vencimiento' }}</strong><small v-if="!detail.canceled && detail.date_renewal" :class="renewalClass(detail)">{{ renewalLabel(detail) }}</small></div><div v-if="detail.service.mode == 'hours'"><span>Cantidad</span><strong>{{ detail.quantity }} {{ detail.service.mode }}</strong></div><div><span>Último pago</span><strong class="crud-services-customers-drawer-service__amount">{{ Intl.NumberFormat('es-AR',{style:'currency',currency:detail.price_list ? detail.price_list.currency.code : 'ARS'}).format(detail.price) }}</strong></div></div><b-button v-if="detail.project_id" variant="link" size="sm" class="crud-services-customers-drawer-service__project" @click="goProject(detail)"><AppIcon name="assignment" class="mr-1" /> Ver proyecto</b-button></article></div><EmptyState v-else icon="design_services" title="No se encontraron servicios" /></div>
          <div class="list-view-drawer__actions"><b-button size="sm" variant="outline-secondary" @click="edit(itemSelected)"><AppIcon name="edit" class="mr-1" /> Editar</b-button><b-button v-if="!itemSelected.canceled" size="sm" variant="outline-danger" @click="openCancel(itemSelected)"><AppIcon name="cancel" class="mr-1" /> Cancelar servicio</b-button><b-button v-else size="sm" variant="outline-secondary" @click="restoreServoceCancel(itemSelected)"><AppIcon name="restore" class="mr-1" /> Restaurar</b-button></div>
        </div>
        <template #footer><div class="list-view-drawer__footer" v-if="itemSelected"><b-button size="sm" variant="outline-danger" block @click="remove(itemSelected)"><AppIcon name="delete" class="mr-1" /> Eliminar</b-button></div></template>
      </b-sidebar>

      <b-card body-class="py-2" class="mt-2">
        <div class="list-view-footer"><b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)"><AppIcon name="back" class="mr-1" /> Volver</b-button><nav><b-pagination class="mb-0" size="sm" pills :total-rows="getRowCount(table.items)" :per-page="table.perPage" v-model="table.currentPage" /></nav></div>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"              
              size="xl"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              :key="modal.form._id"
              :id="modal.form._id">                  
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon :name="crud.form.id ? 'edit' : 'add'" /></span><h5 class="app-modal-header__title">{{ modal.form.title }}</h5></div></template>

        <form-wizard class="crud-services-customers-wizard"
                      title=""
                      subtitle=""
                      nextButtonText="Siguiente"
                      backButtonText="Atrás"
                      finishButtonText="Generar"
                      color="#2f353a"
                      shape="tab"
                      @on-complete="save">

          <tab-content  title="Cliente" 
                        icon="fa fa-handshake-o" 
                        :before-change="servicesCustomersValidStepOne">          
            <b-row>
              <b-col md="6">
                <b-form-group label="Nombre">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.name"
                                required
                                placeholder="Ingresar un nombre">
                  </b-form-input>
                </b-form-group>
              </b-col>    

              <b-col md="6">
                <b-form-group label="Inicio">
                  <b-form-datepicker size="sm" v-model="crud.form.date_init" placeholder="Fecha" local="es"></b-form-datepicker>                      
                </b-form-group>            
              </b-col>    

              <b-col md="6">
                <FindObject render="search"
                            type="customers" 
                            @select-object="loadCustomers($event)" 
                            :valueID="crud.form.customer_id"
                            :where="conditionCustomersActive"/>           
              </b-col>    
              <b-col md="6">
                <FindObject render="search"
                            type="priceList" 
                            @select-object="loadPriceList($event)" 
                            :valueID="crud.form.price_list_id"
                            :key="crud.form.price_list_id"
                            :where="conditionPriceListActive"/>                 
              </b-col>  
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <app-textarea                
                    v-model="crud.form.observations"
                    placeholder="Ingresar las observaciones..."
                    rows="3"
                    max-rows="6"
                  ></app-textarea>
                </b-form-group>
              </b-col>         
            </b-row>      
          </tab-content>
          <tab-content title="Servicios" icon="fa fa-rocket">
            <b-row>
              <b-col lg="12" md="12" sm="12">
                  <Detail :customer_id="crud.form.customer_id" 
                          :date_init="crud.form.date_init"
                          :details="crud.form.services"
                          :price_list_id="crud.form.price_list_id"
                          @load-detail="crud.form.services = $event"
                          :isEdit="crud.form.isEdit"/>
              </b-col>
            </b-row>
          </tab-content>
        </form-wizard>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" 
                    class="mr-1" 
                    @click="close()">
            Salir
          </b-button>              
        </div>
      </b-modal>

      <!-- CRUD CANCEL -->
      <b-modal v-model="modal.cancel.active"
              size="md">
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon name="cancel" /></span><h5 class="app-modal-header__title">{{ modal.cancel.title }}</h5></div></template>

        <b-row>
          <b-col lg="12">
            <b-form-group label="Fecha Finalización">                
              <b-form-datepicker size="sm" v-model="crud.cancel.date_end" placeholder="Fecha" local="es"></b-form-datepicker>                      
            </b-form-group>            
          </b-col>
          <b-col lg="12">
            <b-form-group label="Motivos de Cancelación">
              <app-textarea                
                v-model="crud.cancel.reasons_canceled"
                rows="3"
                max-rows="6"
              ></app-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.cancel.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveCancel()"><AppIcon name="check" class="mr-1" /> Aceptar</b-button>
        </div>
      </b-modal>

  </div>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject'
  import Detail from '@/components/inc/cpbtDetail/detailServices'  
  import Param from '@/config/parameters'
  import Storage from '@/handler/storageLocal'
  import Funciones from '@/handler/funciones'
  import moment from 'moment'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import ModuleViewHeading from '@/components/inc/module/ModuleViewHeading'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      FormWizard,
      TabContent,
      Detail,
      ModuleViewHeading,
      TabHeaderActions,
    },      
    data: () => {
      return {      
        access: {
          module_id: Modules.SERVICIOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudServicesCustomers',
          elements: {}
        }, 
        table : {
          items: [],
          fields: [],
          filter: null,
          currentPage: 1,
          perPage: 50,
          isBusy: false,
        },  
        tableServices : {
          items: [],
          fields: []
        },                 
        crud: {
          form: {
            id: 0,
            name: '',
            date_init: '',
            observations: '',            
            customer_id: 0,
            customer: null,
            services: [],
            isEdit: false,
            price_list_id: 0,
            price_list: null,
            canceled: false,
          }, 
          cancel: {
            id: 0,
            reasons_canceled: '',
            date_end: ''
          }          
        },            
        modal: {
          form: {
            active: false,
            title: ''
          },   
          cancel: {
            active: false,
            title: ''
          },                       
        },  
        arr: {
          servicesCustomers: [],
          filter : {
            customers: [],
            status: [
              {code:false, label: 'Activo'},
              {code:true, label: 'Finalizado'},                
            ],
          }
        },
        filter: {
          name: '',
          customers: [],
          status: [
            {code:false, label: 'Activo'}
          ],
        },
        filtersOpen: false,
        isMobileViewport: false,
        mobileMql: null,
        detailDrawer: false,
        itemSelected: null,
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {     
      this.filtersOpen = Storage.getValue('filters_open_services_customers') == 'true'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.loadFieldTable()
      this.filterLoad() 
      this.filterServicesCustomers()
    },
    beforeDestroy() {
      if(this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    watch: {
      filtersOpen(value) {
        Storage.setValue('filters_open_services_customers', value ? 'true' : 'false')
      }
    },
    computed: {
      conditionCustomersActive(){
        return [{field: 'active', condition: true}];
      },
      conditionPriceListActive(){
        return [{field: 'active', condition: true}];
      },
      visibleTableItems() {
        var start = (this.table.currentPage - 1) * this.table.perPage
        return this.table.items.slice(start, start + this.table.perPage)
      },
      currentServiceCustomerIndex() {
        if (!this.itemSelected) return -1
        return this.visibleTableItems.findIndex(item => item.id == this.itemSelected.id)
      },
      canGoPrevServiceCustomer() {
        return this.currentServiceCustomerIndex > 0
      },
      canGoNextServiceCustomer() {
        return this.currentServiceCustomerIndex >= 0 && this.currentServiceCustomerIndex < this.visibleTableItems.length - 1
      },
    },       
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
        this.loadFieldTable()
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      avatarFromName(name) {
        return Funciones.avatarFromName(name)
      },
      loadFieldTable() {
        this.table.fields = [
          {key: 'id', label: 'ID', sortable: true, class:'align-middle ' + this.alignClass('text-center'), width:'4%'},
          {key: 'customers', label: 'Cliente', class:'align-middle', width:'28%'},
          {key: 'name', label: 'Nombre', class:'align-middle', width:'25%'},
          {key: 'date_init', label: 'Inicio', class:'align-middle ' + this.alignClass('text-center'), width:'10%'},
          {key: 'date_end', label: 'Fin', class:'align-middle ' + this.alignClass('text-center'), width:'10%'},
          {key: 'status', label: 'Estado', class:'align-middle ' + this.alignClass('text-center'), width:'10%'},
          {key: 'reasons', label: this.isMobileViewport ? 'Motivo' : '', class:'align-middle ' + this.alignClass('text-center'), width:'4%'},
          {key: 'f_action', label:this.isMobileViewport ? 'Acción' : '', class:'align-middle', width:'4%'},
        ]
        this.tableServices.fields = [
          {key: 'services', label: 'Servicio', class:'align-middle', width:'24%'},
          {key: 'observations', label:this.isMobileViewport ? 'Observaciones' : '', class:'align-middle', width:'4%'},
          {key: 'date_init', label: 'Inicio', class:'align-middle ' + this.alignClass('text-center'), width:'12%'},
          {key: 'list', label: 'Lista', class:'align-middle ' + this.alignClass('text-center'), width:'10%'},
          {key: 'quantity', label: 'Cantidad', class:'align-middle ' + this.alignClass('text-center'), width:'12%'},
          {key: 'price', label: 'Importe', class:'align-middle ' + this.alignClass('text-right'), width:'16%'},
          {key: 'date_renewal', label: 'Renovación', class:'align-middle ' + this.alignClass('text-center'), width:'22%'},
        ]
      },
      openDetail(item, index, event) {
        if(event && event.target && event.target.closest('button, a, input, select, textarea, .dropdown')) return
        this.itemSelected = item
        this.tableServices.items = item.details || []
        this.detailDrawer = true
      },
      hideDetail() {
        this.detailDrawer = false
        this.itemSelected = null
      },
      goPrevServiceCustomer() {
        if (!this.canGoPrevServiceCustomer) return
        var item = this.visibleTableItems[this.currentServiceCustomerIndex - 1]
        if (item) this.openDetail(item)
      },
      goNextServiceCustomer() {
        if (!this.canGoNextServiceCustomer) return
        var item = this.visibleTableItems[this.currentServiceCustomerIndex + 1]
        if (item) this.openDetail(item)
      },

      getRowCount (items) {
        return items.length
      },    
      load() {
        var result = serviceAPI.obtenerServicesCustomers()

        result.then((response) => {
          var data = response.data
          this.table.items = data   
          
          this.table.isBusy = false
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });        
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.name = ''
        this.crud.form.date_init = ''
        this.crud.form.observations = ''
        this.crud.form.customer_id = 0
        this.crud.form.customer = null   
        this.crud.form.canceled = false   
        this.crud.form.isEdit = false        
        
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Servicios a Cliente"
        this.modal.form.active = true
      },
      edit(item) {                
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.date_init = item.date_init
        this.crud.form.observations = item.observations
        this.crud.form.customer_id = item.customer_id
        this.crud.form.customer = item.customer
        this.crud.form.price_list_id = item.price_list_id
        this.crud.form.price_list = item.price_list
        this.crud.form.canceled = item.canceled
        this.crud.form.isEdit = true

        this.crud.form.services = item.details         

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Servicios de Cliente"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name        

        this.confirmDialog('¿Desea eliminar el servicio “' + this.crud.form.name + '”?', {
          title: 'Eliminar servicio', icon: 'delete', danger: true, okTitle: 'Eliminar'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarServicesCustomers(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.filterServicesCustomers()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [this.$createElement('AppIcon', { props: { name: icon } }), options.title])
        return this.$bvModal.msgBoxConfirm(message, { title: title, size: 'sm', buttonSize: 'sm', okVariant: danger ? 'danger' : 'dark', okTitle: options.okTitle, cancelTitle: options.cancelTitle || 'Cancelar', footerClass: 'p-2', headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header', hideHeaderClose: false, centered: true })
      },
      save() {
        this.confirmDialog('¿Desea guardar el servicio para este cliente?', {
          title: 'Guardar servicio', icon: 'save', okTitle: 'Guardar'
        })
        .then(value => {
          if (value) {                       
            let loader = this.$loading.show();            
            if (this.crud.form.id) {              
              var result = serviceAPI.editarServicesCustomers(this.crud.form);
            } else {
              var result = serviceAPI.agregarServicesCustomers(this.crud.form);
            }

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.filterServicesCustomers()
              this.$awn.success("Datos guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })             
      },   
      close() {
        this.confirmDialog('¿Desea salir de la carga del servicio?', {
          title: 'Salir sin guardar', icon: 'warning', okTitle: 'Salir'
        })
        .then(value => {
          if (value) {  
            this.modal.form.active = false
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })          
      },

      loadCustomers (object) {        
        if(object){
          this.crud.form.customer = object
          this.crud.form.customer_id = object.id    
          
         if(!this.crud.form.price_list_id) {
            if(object.price_list) {
              if(object.price_list.list) {              
                this.crud.form.price_list = object.price_list.list
                this.crud.form.price_list_id = object.price_list.list.id
              }
            }          
          }            
        } else {
          this.crud.form.customer = null
          this.crud.form.customer_id = 0
        }
      },
      loadPriceList (object) {
        if(object){
          this.crud.form.price_list = object
          this.crud.form.price_list_id = object.id             
        } else {
          this.crud.form.price_list = null
          this.crud.form.price_list_id = 0
        }
      },   

      servicesCustomersValidStepOne() {
        if(!this.crud.form.date_init) {
          this.$awn.alert("No se cargó la fecha de inicio");
          return false
        }

        if(!this.crud.form.name) {
          this.$awn.alert("No se cargó un nombre de referencia");
          return false
        }

        if(!this.crud.form.customer_id) {
          this.$awn.alert("No se cargó ningún cliente");
          return false
        }

        return true        
      }, 

      filterLoad() {
        this.filterLoadCustomers()

        this.restoreFilterStorage() 
      },
      filterLoadCustomers() {
        var result = serviceAPI.obtenerClientes()        
        result.then((response) => {
          var data = response.data    
          
          let arrActive = []
          let arrInactive = []
          data.forEach(element => {            
            if(element.active)
              arrActive.push({ code: element.id, label: element.name })            
            else 
              arrInactive.push({ code: element.id, label: '[INACTIVO] - ' + element.name })            
          });   
          this.arr.filter.customers = arrActive.concat(arrInactive);
        })   
      },
      filterServicesCustomers(){   
        this.saveFilterStorage()     

        this.table.isBusy = true 
   
        var result = serviceAPI.filtrarServiceCustomers(this.filter)        
        result.then((response) => {          
          var data = response.data
          this.table.items = data
          this.arr.servicesCustomers = data

          if(this.itemSelected) {
            var selected = this.table.items.find(item => item.id == this.itemSelected.id)
            if(selected) {
              this.itemSelected = selected
              this.tableServices.items = selected.details || []
            } else {
              this.hideDetail()
            }
          }

          this.table.isBusy = false
        })
        .catch(error => {          
          this.table.isBusy = false          
          this.$awn.alert(Error.showError(error))
        });          
      },  
      
      openCancel(item) {
        this.crud.cancel.id = item.id
        this.crud.cancel.date_end = moment().format('YYYY-MM-DD')
        this.crud.cancel.reasons_canceled = ''
        
        this.modal.cancel.active = true
        this.modal.cancel.title = "Cancelar Servicio"
      },
      saveCancel() {
        this.confirmDialog('¿Desea cancelar el servicio?', {
          title: 'Cancelar servicio', icon: 'cancel', danger: true, okTitle: 'Cancelar servicio'
        })
        .then(value => {
          if (value) {      
            let loader = this.$loading.show();
            var result = serviceAPI.cancelarServicesCustomers(this.crud.cancel);

            result.then((response) => {      
              this.modal.cancel.active = false        
              loader.hide()
              this.filterServicesCustomers()
              this.$awn.success("Servicio Cancelado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }  
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })          
      },
      restoreServoceCancel(item) {
        this.confirmDialog('¿Desea restaurar el servicio?', {
          title: 'Restaurar servicio', icon: 'restore', okTitle: 'Restaurar'
        })
        .then(value => {
          if (value) {      
            let loader = this.$loading.show();            
            
            this.crud.cancel.id = item.id            
            var result = serviceAPI.restaurarServicesCustomers(this.crud.cancel);

            result.then((response) => {      
              this.modal.cancel.active = false        
              loader.hide()
              this.filterServicesCustomers()
              this.$awn.success("Servicio Restaurado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }  
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })          
      },   
      
      daysForRenewal(item) {        
        var date1 = moment();
        var date2 = moment(item.date_renewal);

        return date2.diff(date1, 'days') + 1;
      },
      daysVtoRenewal(item) {        
        var date1 = moment(item.date_renewal);
        var date2 = moment();

        return date2.diff(date1, 'days') + 1;
      },  
      renewalLabel(item) {
        var days = moment(item.date_renewal).startOf('day').diff(moment().startOf('day'), 'days')
        if(days < 0) return 'Vencido hace ' + Math.abs(days) + ' día/s'
        if(days === 0) return 'Vence hoy'
        return 'Faltan ' + days + ' día/s'
      },
      renewalClass(item) {
        var days = moment(item.date_renewal).startOf('day').diff(moment().startOf('day'), 'days')
        if(days < 0) return 'crud-services-customers-drawer-service__renewal--danger'
        if(days < 5) return 'crud-services-customers-drawer-service__renewal--warning'
        return 'crud-services-customers-drawer-service__renewal--success'
      },
      
      goProject(item) {
        this.$router.push({ name: 'ProjectStaffDetailHoursProjects', params: { projectID: item.project_id } })                  
      },   
      
      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_services_customers', JSON.stringify(this.filter))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_services_customers')) {
          this.filter = JSON.parse(Storage.getValue('filter_services_customers'))
        }         
      },      
    }    
  }
</script>
<style>
  .crud-services-customers-wizard .wizard-header { padding: 0; }
  .crud-services-customers-drawer__header { background: var(--app-color-primary-soft); border: 1px solid var(--app-color-info-border); border-radius: 10px; padding: 12px; }
  .crud-services-customers-drawer__header .list-view-drawer__code { color: var(--app-color-primary-active); }
  .crud-services-customers-drawer__avatar { flex: 0 0 42px; height: 42px !important; width: 42px !important; }
  .crud-services-customers-drawer__observations { color: var(--app-color-text-secondary); font-size: var(--app-text-sm); line-height: 1.45; }
  .crud-services-customers-drawer__observations p { margin-bottom: 6px; }
  .crud-services-customers-drawer-services { display: grid; gap: 6px; }
  .crud-services-customers-drawer-service { background: var(--app-color-surface); border: 1px solid var(--app-color-border); border-radius: 9px; overflow: hidden; }
  .crud-services-customers-drawer-service > header { align-items: center; background: var(--app-color-surface-subtle); border-bottom: 1px solid var(--app-color-border); display: flex; gap: 7px; padding: 6px 8px; }
  .crud-services-customers-drawer-service__icon { align-items: center; background: var(--app-color-info-soft); border-radius: 50%; color: var(--app-color-info); display: inline-flex; flex: 0 0 24px; height: 24px; justify-content: center; }
  .crud-services-customers-drawer-service__icon .material-symbols-rounded { font-size: 15px; }
  .crud-services-customers-drawer-service header > div { min-width: 0; }
  .crud-services-customers-drawer-service header strong,
  .crud-services-customers-drawer-service header span:not(.crud-services-customers-drawer-service__icon):not(.crud-services-customers-drawer-service__status) { display: block; }
  .crud-services-customers-drawer-service header strong { color: var(--app-color-text); font-size: var(--app-text-sm); line-height: 1.25; }
  .crud-services-customers-drawer-service header div > span { color: var(--app-color-text-secondary); font-size: var(--app-text-xs); margin-top: 2px; }
  .crud-services-customers-drawer-service__status { border: 1px solid; border-radius: 999px; font-size: 10px; font-weight: var(--app-font-semibold); margin-left: auto; padding: 2px 5px; white-space: nowrap; }
  .crud-services-customers-drawer-service__status--active { background: var(--app-color-success-soft); border-color: var(--app-color-success-border); color: var(--app-color-success); }
  .crud-services-customers-drawer-service__status--ended { background: var(--app-color-danger-soft); border-color: var(--app-color-danger-border); color: var(--app-color-danger); }
  .crud-services-customers-drawer-service__observations { background: var(--app-color-info-soft); border-bottom: 1px solid var(--app-color-info-border); color: var(--app-color-text-secondary); font-size: var(--app-text-xs); line-height: 1.3; padding: 6px 8px; }
  .crud-services-customers-drawer-service__observations p { margin: 0; }
  .crud-services-customers-drawer-service__data { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0; }
  .crud-services-customers-drawer-service__data > div { align-items: baseline; border-top: 1px solid var(--app-color-border); display: flex; flex-wrap: wrap; gap: 4px; padding: 4px 8px; }
  .crud-services-customers-drawer-service__data > div:nth-child(odd) { border-right: 1px solid var(--app-color-border); }
  .crud-services-customers-drawer-service__data span { color: var(--app-color-text-secondary); font-size: 10px; text-transform: uppercase; }
  .crud-services-customers-drawer-service__data strong { color: var(--app-color-text); font-size: var(--app-text-sm); }
  .crud-services-customers-drawer-service__data small { display: block; flex-basis: 100%; font-size: 10px; font-weight: var(--app-font-semibold); line-height: 1.1; }
  .crud-services-customers-drawer-service__renewal--success { color: var(--app-color-success); }
  .crud-services-customers-drawer-service__renewal--warning { color: var(--app-color-warning-hover); }
  .crud-services-customers-drawer-service__renewal--danger { color: var(--app-color-danger); }
  .crud-services-customers-drawer-service__amount { color: var(--app-color-success) !important; }
  .crud-services-customers-drawer-service__project { color: var(--app-color-primary) !important; padding: 5px 8px !important; }
</style>
<style scoped>
  .crud-services-customers-reasons-canceled {
    cursor: pointer;
  }
  .crud-services-vto-warning {
    background: var(--app-color-warning-soft);
    border: 1px solid var(--app-color-warning-border);
    color: var(--app-color-warning-hover);
    font-weight: var(--app-font-semibold);
    padding: 3px 5px;
  }
  .crud-services-vto-success {
    background: var(--app-color-success-soft);
    border: 1px solid var(--app-color-success-border);
    color: var(--app-color-success);
    font-weight: var(--app-font-semibold);
    padding: 3px 5px;
  }  
  .crud-services-vto-danger {
    background: var(--app-color-danger-soft);
    border: 1px solid var(--app-color-danger-border);
    color: var(--app-color-danger);
    font-weight: var(--app-font-semibold);
    padding: 3px 5px;
  }    
  .popover-observations {
    cursor: pointer;
  }  
  .btn.crud-services-customers-action-toggle { align-items: center; background: transparent !important; border: none !important; box-shadow: none !important; color: var(--app-color-text-secondary) !important; display: inline-flex !important; font-size: var(--app-text-sm); padding: 0 !important; }
  .crud-services-customers-table-footer { padding-right: 12px; }
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;    
  }  
</style>
